import {AxiosRequestConfig} from 'axios'
import RequestBase from '../../../api/RequestBase'

const BASE_URL = '/download'

const resolveKey = (key: string, config?: AxiosRequestConfig) => {
  return RequestBase.get(`${BASE_URL}/resolve`, {
    ...config,
    params: {key},
  })
}

const resendLink = (key: string, config?: AxiosRequestConfig) => {
  return RequestBase.post(`${BASE_URL}/resend`, {key}, config)
}

const DownloadService = {
  resolveKey,
  resendLink,
}

export default DownloadService
